import { InputHTMLAttributes } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@void-orbit/ui";

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  label?: string;
  error?: FieldError;
  registerProps?: UseFormRegisterReturn;
  showPassword?: boolean;
  endAdornment?: React.ReactNode;
};

export const TextField = ({
  placeholder,
  type = "text",
  label,
  error,
  registerProps,
  showPassword = true,
  endAdornment,
  ...inputProps
}: TextFieldProps ) => {
  const { ref, ...register } = registerProps ?? {};

  return (
    <Input
      { ...inputProps }
      { ...register }
      ref={ ref }
      type={ showPassword ? type : "password" }
      placeholder={ placeholder ?? "" }
      label={ label }
      error={ error?.message }
      endAdornment={ endAdornment }
    />
  );
};
